// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable-next-line selector-class-pattern -- класс консты */
.PlaceablePopover__Popover___qQK4o {
    pointer-events: var(--popover-pointer-events);

    position: absolute;
    top: var(--popover-top);
    left: var(--popover-left);

    width: var(--popover-width);

    visibility: var(--popover-visibility);

    &.PlaceablePopover__notVisible___zRVgv {
        pointer-events: none;

        position: absolute;
        top: -100vh;
        left: -100vw;

        visibility: hidden;
    }
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/PlaceablePopover/PlaceablePopover.css"],"names":[],"mappings":"AAAA,uEAAuE;AACvE;IACI,6CAA6C;;IAE7C,kBAAkB;IAClB,uBAAuB;IACvB,yBAAyB;;IAEzB,2BAA2B;;IAE3B,qCAAqC;;IAErC;QACI,oBAAoB;;QAEpB,kBAAkB;QAClB,WAAW;QACX,YAAY;;QAEZ,kBAAkB;IACtB;AACJ","sourcesContent":["/* stylelint-disable-next-line selector-class-pattern -- класс консты */\n.Popover {\n    pointer-events: var(--popover-pointer-events);\n\n    position: absolute;\n    top: var(--popover-top);\n    left: var(--popover-left);\n\n    width: var(--popover-width);\n\n    visibility: var(--popover-visibility);\n\n    &.notVisible {\n        pointer-events: none;\n\n        position: absolute;\n        top: -100vh;\n        left: -100vw;\n\n        visibility: hidden;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Popover": `PlaceablePopover__Popover___qQK4o`,
	"notVisible": `PlaceablePopover__notVisible___zRVgv`
};
export default ___CSS_LOADER_EXPORT___;
